import { useEffect, useLayoutEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { RoutesNames } from './navigationRoutes';
import { useCommConnection } from '@/components/communication/useCommConnection';
import { ShopMessagesPanel } from '@/components/communication/ShopMessagesPanel';
import useStore from '@/store/store';
// import Auth from '@/shared/config/Auth';
// import Navigation from '@/ui/navigation/Navigation';
// import HeaderPanel from "@/layout/header-panel/HeaderPanel";

export const LoggedInLayout = () => {
	// const { type: navigationType, element: navigationElement } = useCustomNavigation();
	const navigate = useNavigate();
	const location = useLocation();
	// Communication Center: unread counts and real-time updates for every page.
	useCommConnection();
	const { user } = useStore();

	useLayoutEffect(() => {
		if (location.pathname === '/') {
			navigate(RoutesNames.LIVE, { replace: true });
		}
	}, []);

	return (
		<>
			{/* <HeaderPanel /> */}

			{['shop', 'admin', 'master'].includes(user?.role) ? (
				// The messages column can stay open on the left of every page.
				<div className='flex items-start'>
					<ShopMessagesPanel />
					{/* Only the width left next to the column (the class alone takes the whole screen). */}
					<div
						className='app-main-container min-w-0 flex-1'
						style={{ width: 'auto', maxWidth: '100%' }}
					>
						<Outlet />
					</div>
				</div>
			) : (
				<div className='app-main-container'>
					<Outlet />
				</div>
			)}
		</>
	);
};
